module.exports = __webpack_public_path__ + "01_freckles.04b741d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer2/01_freckles.png
// module id = kMta
// module chunks = 0